export default "__VITE_ASSET__De5ETyqj__"